import React from 'react';
import { format } from 'date-fns';
import DOMPurify from 'dompurify';

function Blogpost2({ title, content, author, createdAt }) {
    return (
        <article className="blog-post">
            <h3>{title}</h3>
            <div className="post-meta">
                <span>By: {author}</span>
                <time dateTime={createdAt}>
                    {format(new Date(createdAt), 'MMMM d, yyyy')}
                </time>
            </div>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
        </article>
    );
}

export default Blogpost2;